<template>
  <div class="section-prize-awards-sub-about" :class="[{ 'is-alt': isAlt }]" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subheader title="Here's Your Chance To Win Even If Your Bar-b-que Doesn't" style="margin-bottom:2em;"></page-subheader>

    <div-container>

      <div-columns v-for="(item, ikey) in items" :key="`${ikey}`"
        paddingTop="0" paddingBottom="0"
        v-if="item && item.imageUrl">
        <div class="columns is-gapless is-centered row" v-if="item">
          <div class="column is-5 has-text-centered">
            <img :src="item.imageUrl" width="200" style="width:100%;" />
          </div>
          <div class="column is-7 has-text-left">
            <h2 style="margin-bottom:0;padding-bottom:30px;">{{ item.title }}</h2>
            <div v-html="item.content" />
          </div>
        </div>
      </div-columns>
      <!-- <div-columns paddingTop="0.5em" :class="{ 'with-image': imageUrl !== undefined }" >
        <div v-html="paragraph.content" />
      </div-columns> -->
      <!-- <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        <p v-html="error">
        </p>
      </div> -->

    </div-container>
  </div>
</template>

<script>
import _ from 'lodash'
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import ShowDown from 'showdown'
import 'showdown-target-blank'

export default {
  name: 'section-prize-awards-sub-about',
  props: ['name-like', 'is-alt'],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader
  },
  data () {
    return {
      items: {},
      maxItems: 10,
      imageUrl: undefined,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    let nameLike = this.nameLike
    for (var i = 1; i <= this.maxItems; i++) {
      let name = `${nameLike}-${i}`
      // var name = this.names[i]
      this.$set(this.items, name, { loading: true })
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getItems: async function (name) {
      this.loading = true
      this.error = undefined
      try {
        let data = await Site.aboutWithName(name)
        this.loading = false
        // console.log(data)
        if (!data || !data.content) {
          // this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        this.onComplete(name, data)
      } catch (error) {
        this.loading = false
        // this.error = 'Unable to load, please kindly refresh the page.'
        // console.log(error)
      }
      // let data = await Site.aboutWithName(name)
      // .then((data) => {
      //   this.loading = false
      //   // console.log(data)
      //   if (!data || !data.content) {
      //     // this.error = 'Unable to load, please kindly refresh the page.'
      //     return
      //   }
      //
      //   this.onComplete(name, data)
      //
      //   // var converter = new ShowDown.Converter({ extension: ['targetblank'] })
      //   // var html = converter.makeHtml(data.content)
      //   // var paragraph = {}
      //   // paragraph.content = html
      //   // paragraph.title = data.title
      //   // paragraph.imageUrl = data.image ? data.image.path : undefined
      //   //
      //   // this.items[name] = paragraph
      //   // this.items[name].loading = false
      //   // console.log(this.items[name])
      // })
      // .catch((error) => {
      //   this.loading = false
      //   this.error = 'Unable to load, please kindly refresh the page.'
      //   console.log(error)
      // })
    },

    refresh: async function () {
      let promises = []
      let promise
      let keys = _.keys(this.items)
      for (var i = 0; i < keys.length; i++) {
        promise = this.getItems(keys[i])
        promises.push(promise)
      }
      await Promise.all(promises)
    },

    onComplete: function (name, data) {
      var converter = new ShowDown.Converter({ extension: ['targetblank'] })
      var html = converter.makeHtml(data.content)
      this.$set(this.items, name, {
        loading: false,
        content: html,
        title: data.title,
        imageUrl: data.image ? data.image.path : undefined
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section about

.section-prize-awards-sub-about {
  &.is-alt {
    background-color: $color-orange;
  }

  padding-top: 3rem;
  padding-bottom: 3rem;

  @import "../styles/markdown.scss";

  .columns.is-gapless {
    & > .column {
      &.content {
        img {
          padding: 30px 15px;

          @media screen and (min-width: $tablet) {
            padding: 4px 10px;
          }

          @media screen and (min-width: $desktop) {
            padding: 4px 30px;
          }
        }
      }
    }

    &:last-child.row {
      margin-bottom: 2em;

      @media screen and (min-width: $desktop) {
        margin-bottom: 3em;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// AboutPrizeAwardsSubSection.vue?80531bec